import { IS_DEVELOPMENT } from '../constants/common';

export function generateQuoteProposalPageURL(proposalId: string, vendorGUID: string) {
  return `https://app${
    IS_DEVELOPMENT ? '.dev' : ''
  }.trnsact.com/quoteproposal/?vendorGUID=${vendorGUID}&proposalId=${proposalId}&viewOnly=true`;
}
